import(/* webpackMode: "eager" */ "/app/src/app/network-dao/layout.tsx")